<template>
  <apply-document />
</template>

<script>
import ApplyDocument from './ApplyDocument.vue'

export default {
  components: {
    ApplyDocument,
  },
}
</script>

<style scoped>

</style>
